(() => {
  const cfg = document.querySelector('[data-sq-behavior]');
  if (!cfg || window.sqCartActionsReady) return;
  window.sqCartActionsReady = true;
  const toast = document.querySelector('[data-sq-feedback]');
  let timer;
  function notify(message, persistent = false) {
    if (!toast) return;
    clearTimeout(timer);
    toast.querySelector('[data-sq-feedback-text]').textContent = message;
    toast.hidden = false;
    if (!persistent) timer = setTimeout(() => { toast.hidden = true; }, 7000);
  }
  toast?.querySelector('[data-sq-dismiss]')?.addEventListener('click', () => { toast.hidden = true; });
  document.addEventListener('sooqja:cart:uncertain', () => notify(cfg.dataset.uncertain || cfg.dataset.error, true));
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('[data-sq-add],.sooqja-product__form')) return;
    event.preventDefault();
    if (form.dataset.busy === '1' || !form.reportValidity()) return;
    const select = form.querySelector('[data-variant-select]');
    const button = form.querySelector('button[type=submit]');
    if (button?.disabled || (select && select.selectedOptions[0]?.dataset.available !== 'true')) return;
    const card = form.closest('[data-cross-sell-card]');
    const recommendations = card?.closest('[data-sq-complements]');
    const source = {
      placement: recommendations?.dataset.placement || (form.matches('.sooqja-product__form') ? 'product' : 'product_card'),
      recommendation_source: card?.dataset.crossSellSource || '',
      source_product_id: recommendations?.dataset.sourceProductId || '',
      rank: Number(card?.dataset.crossSellRank || 0)
    };
    const feedback = form.querySelector('[data-sq-product-feedback]');
    if (feedback) { feedback.hidden = true; feedback.textContent = ''; }
    form.dataset.busy = '1';
    const linked = [button, ...document.querySelectorAll('[data-sticky-add]')]
      .filter(item => item && (item === button || item.getAttribute('form') === form.id));
    const original = linked.map(item => item.textContent);
    linked.forEach(item => { item.disabled = true; item.setAttribute('aria-busy', 'true'); item.textContent = cfg.dataset.adding; });
    let added = false;
    try {
      const data = new FormData(form);
      for (const key of [...data.keys()]) if (key.startsWith('sq_option_')) data.delete(key);
      const drawer = document.querySelector('cart-drawer');
      if (drawer?.getSectionsToRender) {
        data.set('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
        data.set('sections_url', location.pathname);
      }
      const requestedQuantity = Math.max(1, Number(data.get('quantity')) || 1);
      const result = await window.sqCartRequest(cfg.dataset.addUrl + '.js', {
        method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: data
      });
      added = true;
      const item = result.items?.[0] || result;
      document.dispatchEvent(new CustomEvent('sooqja:cart:add-success', { detail: {
        ...source, currency: cfg.dataset.currency,
        item: {
          product_id: String(item.product_id || ''), variant_id: String(item.variant_id || item.id),
          title: item.product_title || item.title || '', quantity: requestedQuantity,
          price: Number(item.final_price ?? item.price) / 100
        }
      } }));
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sooqja-market', productVariantId: String(data.get('id')), cartData: result });
      }
      if (drawer?.renderContents && !document.querySelector('[data-sooqja-cart]')) {
        try {
          drawer.setActiveElement?.(button);
          if (result._sqCartRevision === window.sqCartRevision) await drawer.renderContents(result);
        } catch (_) { notify(cfg.dataset.added); }
      } else notify(cfg.dataset.added);
      if (item.product_id) document.querySelectorAll(`[data-sq-complements] [data-product-id="${item.product_id}"]`).forEach(element => {
        const parent = element.closest('[data-sq-complements]');
        const heldFocus = element.contains(document.activeElement);
        element.remove();
        if (!parent.querySelector('[data-cross-sell-card]')) parent.remove();
        if (heldFocus) document.querySelector('[data-sooqja-cart] [name="checkout"]')?.focus({ preventScroll: true });
      });
      try {
        const revision = window.sqCartRevision;
        const cart = await window.sqCartRead(cfg.dataset.cartUrl + '.js');
        if (revision === window.sqCartRevision && !window.sqCartWritesPending) {
          document.querySelectorAll('[data-sq-cart-count]').forEach(element => { element.textContent = cart.item_count; });
        }
      } catch (_) { /* A count refresh cannot turn a successful add into a failed add. */ }
    } catch (error) {
      const message = added ? cfg.dataset.added : error.sqCartUncertain ? (cfg.dataset.uncertain || cfg.dataset.error) : (error.message || cfg.dataset.error);
      notify(message, !added);
      if (feedback && !added) { feedback.textContent = message; feedback.hidden = false; }
    } finally {
      delete form.dataset.busy;
      const current = form.querySelector('[data-variant-select]');
      const available = current ? current.selectedOptions[0]?.dataset.available === 'true' : form.dataset.available !== 'false';
      const productRoot = form.closest('[data-sooqja-product]');
      linked.forEach((item, index) => {
        item.removeAttribute('aria-busy');
        item.textContent = available ? original[index] : (productRoot?.dataset.soldoutLabel || cfg.dataset.soldout || original[index]);
        item.disabled = !available;
      });
    }
  });
})();
